var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    clipPath: "url(#clip0_1892_1667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095493"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 19,
    cy: 19.1401,
    r: 18,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M27.075 18.5102C27.175 18.568 27.175 18.7123 27.075 18.77L14.325 26.1313C14.225 26.189 14.1 26.1168 14.1 26.0014L14.1 11.2789C14.1 11.1635 14.225 11.0913 14.325 11.149L27.075 18.5102Z",
    stroke: "black",
    strokeWidth: 1.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1892_1667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 42,
    fill: "white",
    transform: "translate(0 0.140137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.ccfd481450e3f0d74145d2ccdd0b4add.svg";
export { ForwardRef as ReactComponent };